/**
 * DeployCohortCoursewareModal Messages
 *
 * This contains all the text for the DeployCohortCoursewareModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.courseware.enrollmentLinksModal';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Enrollment URLs',
  },
  studentSignupLabel: {
    id: `${scope}.studentSignupLabel`,
    defaultMessage: 'Direct sign-up URL',
  },
  studentSignupURL: {
    id: `${scope}.studentSignupURL`,
    defaultMessage: 'Sign-up URL',
  },
  ltiEnrollmentLabel: {
    id: `${scope}.ltiEnrollmentLabel`,
    defaultMessage: 'LMS Integration (via LTI)',
  },
  ltiEnrollmentURL: {
    id: `${scope}.ltiEnrollmentURL`,
    defaultMessage: 'Provider URL',
  },
  ltiKey: {
    id: `${scope}.ltiKey`,
    defaultMessage: 'Consumer key',
  },
  ltiSecret: {
    id: `${scope}.ltiSecret`,
    defaultMessage: 'Consumer secret',
  },
  copyPrompt: {
    id: `${scope}.copyPrompt`,
    defaultMessage: 'Copy',
  },
  copyConfirm: {
    id: `${scope}.copyConfirm`,
    defaultMessage: 'Copied to clipboard',
  },
});
